import { customElement as litCustomElement } from 'lit/decorators.js';

type NonEmptyString<T extends string> = '' extends T ? never : T;
export type SdsTagName<T extends string> = `sds-${NonEmptyString<T>}`;

export function guardedCustomElement<Tag extends string>(tagName: SdsTagName<Tag>): ClassDecorator {
	return (cls) => {
		if (!customElements.get(tagName)) {
			litCustomElement(tagName)(cls);
		}
	};
}
